import { Link } from "react-router-dom";
import { ArrowRight, WhatsappLogo, Phone } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { HOW_IT_WORKS_PAGE, CONTACT, GALLERY } from "../data/content";

const HowItWorksPage = () => (
  <main data-testid="how-it-works-page" className="bg-brand-bone">
    <Seo
      title="How It Works — First Call to Keys"
      description="Your journey with BTK Mortgage Services, step by step. From a 15-minute first call to keys in your hand — no jargon, no surprises."
      path="/how-it-works"
      image={GALLERY[2]}
    />
    <PageHero
      testId="hiw-hero"
      eyebrow="How it works"
      title="Your journey with us,"
      italic="step by step."
      intro="No jargon, no surprises. Here's exactly what happens from your first call through to completion — and beyond."
      image={GALLERY[2]}
    />

    <section className="mx-auto max-w-4xl px-5 py-20 sm:px-8 sm:py-28">
      <ol className="relative space-y-10 border-l border-brand-gold/40 pl-10 sm:pl-14">
        {HOW_IT_WORKS_PAGE.map((step, i) => (
          <Reveal key={step.title} delay={0.04}>
            <li data-testid={`hiw-step-${i + 1}`} className="relative">
              <span
                aria-hidden
                className="absolute -left-[52px] top-0 flex h-10 w-10 items-center justify-center bg-brand-ink text-[0.68rem] font-semibold tracking-[0.1em] text-white sm:-left-[72px] sm:h-12 sm:w-12 sm:text-[0.75rem]"
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="border border-black/10 bg-white p-8 transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:border-brand/30 hover:shadow-[0_20px_52px_rgba(10,19,38,0.08)] sm:p-10">
                <div className="flex flex-wrap items-center gap-3">
                  <h2 className="editorial-h text-2xl text-brand-ink">{step.title}</h2>
                  {step.tag && (
                    <span className="border border-brand/30 px-3 py-1 text-[0.6rem] font-semibold uppercase tracking-[0.22em] text-brand">
                      {step.tag}
                    </span>
                  )}
                </div>
                <p className="mt-4 text-sm leading-relaxed text-neutral-600 sm:text-base">{step.text}</p>
              </div>
            </li>
          </Reveal>
        ))}
      </ol>
    </section>

    <section className="relative bg-brand-ink py-24 sm:py-28 overflow-hidden">
      <img aria-hidden src={GALLERY[3]} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-gradient-to-r from-brand-ink via-brand-ink/90 to-brand-ink/60" />
      <div className="relative mx-auto max-w-4xl px-5 sm:px-8">
        <Reveal>
          <p className="eyebrow text-brand-gold"><span className="rule-line" />Begin</p>
          <h2 className="editorial-h mt-6 text-3xl text-white sm:text-5xl">
            Ready for <span className="italic text-brand-gold">step one?</span>
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-white/70">
            Book a no-obligation 15-minute call and we'll talk through your options — or reach us
            whichever way suits you.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/contact"
              data-testid="hiw-book-call-btn"
              className="group inline-flex items-center gap-2 bg-brand px-8 py-4 text-[0.78rem] font-semibold uppercase tracking-[0.22em] text-white transition-[background-color,transform] duration-200 hover:bg-brand-dark hover:-translate-y-0.5"
            >
              Book a call
              <ArrowRight size={14} weight="bold" />
            </Link>
            <a
              href="https://wa.me/+4401344578847"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hiw-whatsapp-link"
              className="inline-flex items-center gap-2 border border-white/30 px-8 py-4 text-[0.78rem] font-semibold uppercase tracking-[0.22em] text-white transition-[background-color,border-color] duration-200 hover:border-white hover:bg-white/5"
            >
              <WhatsappLogo size={15} weight="duotone" />
              WhatsApp us
            </a>
            <a
              href={CONTACT.phoneHref}
              data-testid="hiw-phone-link"
              className="inline-flex items-center gap-2 border border-white/30 px-8 py-4 text-[0.78rem] font-semibold uppercase tracking-[0.22em] text-white transition-[background-color,border-color] duration-200 hover:border-white hover:bg-white/5"
            >
              <Phone size={15} weight="duotone" />
              Call an advisor
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  </main>
);

export default HowItWorksPage;
